<template>
    <div>
        <v-dialog v-model="showDetailDialog" persistent>
            <div class="card" style="width: 100%;">
                <div class="d-flex align-center mt-2 mb-2" style="justify-content: space-between;">
                    <div class="d-flex align-center">
                        <v-img :src="require('../../img/icons-write.png')" max-height="24px" max-width="24px" alt="logo"
                            contain></v-img>
                        <div style="margin-left: 10px;">
                            {{ $i18n.t('ppt_addin.dialog.onepageslide_title') }}
                        </div>
                    </div>
                    <button style="margin-left: 5px;" @click="closeDialog()">
                        <v-icon>mdi-close-circle-outline</v-icon>
                    </button>
                </div>
                <div>
                    <v-textarea ref="refInputTextArea" :value="translateDetail" counter
                        placeholder="你好" solo :rows="$t(rows)"
                        background-color="rgb(251,255,242)" style="font-size: 13px"></v-textarea>
                </div>
            </div>
        </v-dialog>
    </div>
</template>

<script>

export default {
    props: {
        translateDetail: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            showDetailDialog: false,
            rows:0,
        }
    },
    methods: {
        adjustHeight() {
            const maxHeight = window.innerHeight // 当前可视区高度  
            this.rows = Math.ceil((maxHeight - 350) / 30) // 求出当前输入框最优行数
        },
        closeDialog() {
            this.showDetailDialog = false
        },
        showDialog() {
            this.showDetailDialog = true
        }
    },
    mounted() {
        window.addEventListener('resize', this.adjustHeight);
        this.adjustHeight();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.adjustHeight)
    }
}
</script>